import { render, staticRenderFns } from "./AdminShowHome.vue?vue&type=template&id=f0c50ec2"
import script from "./AdminShowHome.vue?vue&type=script&lang=js"
export * from "./AdminShowHome.vue?vue&type=script&lang=js"
import style0 from "./AdminShowHome.vue?vue&type=style&index=0&id=f0c50ec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports